<script>
    export default {
        name: 'AuthVerifyEnterCode',

        props: {
        },

        data() {
            return {
                inputCode: ''
            }
        },
        computed: {
            disabledButton: function() {
                return !this.inputCode || this.inputCode.length < 6;
            }
        }
    }
</script>
<template>
    <div class="form-group">
        <label for="token" class="form-label">Verification Code</label>
        <input id="token" class="form-control" type="text" name="token" v-model="inputCode" autofocus>
        <div class="pt-3 pt-md-4">
            <button type="submit" class="submit btn btn-primary" :disabled="disabledButton">Continue</button>
        </div>
    </div>
</template>
<style scoped>
</style>
